module.exports = __webpack_public_path__ + "img/펜서.fb40ba50.png";